import { useEffect, useRef } from 'react';

import { ErrorView } from '@gasbi/shared';
import { useTranslation } from 'react-i18next';

const LOGOUT_IN_MS = 3000;

// Shown to someone who signed in but has no place in this cabinet (403 from the API). After a
// moment the session is ended through the cabinet API's logout endpoint, so the next visit
// starts from the Identity Server login page.
const Page = () => {
  const { t } = useTranslation();
  const firedRef = useRef(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (firedRef.current) return;
      firedRef.current = true;
      window.location.assign('/api/logout?returnUrl=/');
    }, LOGOUT_IN_MS);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <ErrorView
      title={t('notAuthorized.title')}
      description={t('notAuthorized.description')}
      hideHeader
      hideButton
    />
  );
};

export default Page;
